import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-ppp-opt-in',
  template: `
    <div class="activity-message">
      <div>
        <div class="description">
          <strong>
          {{ activity.meta.automated ? ' Automated ' : '' }} PPP Opt-in
          {{ activity.meta.attemptNumber ? ' (Email Attempt ' + activity.meta.attemptNumber + ')' : '' }}
          </strong>
          <span>Business marked as opting in for PPP loans</span>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class ActivityRowPPPOptInComponent {

  @Input() activity;
}
